module.exports = __webpack_public_path__ + "static/media/mainvideo.af9bfc1c.mp4";